import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { HomeScreen, SinisterStatus, Testing } from '../screens';
import { StepperClaim } from '../screens/stepper';
import InactiveScreen from '../screens/InactiveScreen';
import useSiniestrosStore from '../store/siniestrosStore';
import { useEffect, useState } from 'react';
import { Loader } from '../components';
import { isEmpty } from '../utils/functions';

export default function Rutas() {
  const { getConfig, config } = useSiniestrosStore();
  const [loading, setLoader] = useState(true);
  const [testingPage, setTestingPage] = useState(false);

  useEffect(() => {
    (async () => {
      await getConfig();
    })();
  }, []);

  useEffect(() => {
    if (!isEmpty(config.app_status_active)) {
      setLoader(false);
    }

    if (isEmpty(config.app_testing_page)) {
      setTestingPage(false);
    } else {
      setTestingPage(config.app_testing_page);
    }
  }, [config.app_status_active, config.app_testing_page]);

  if (loading) {
    return (
      <div className='flex flex-col justify-center h-[100vh]'>
        <Loader />
      </div>
    )
  }

  if (config && config.app_status_active === false) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/inactivo" element={<InactiveScreen />} />
          <Route path="*" element={<Navigate to="/inactivo" replace />} />
        </Routes>
      </BrowserRouter>
    )
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="stepper/:step" element={<StepperClaim />} />
        {
          testingPage === true ?
            <>
              <Route path="/test" element={<Testing />} />
              <Route path="/instance/:instance" element={<Testing />} />
            </>
            :
            <></>
        }
        <Route path="/sinister-status" element={<SinisterStatus />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

